import { AppEvent } from 'types/appEvent';
import { createReducer } from 'utils/reducer/reducerUtils';

export const reduceToNextDemoStackUrl = createReducer<
  undefined | null | string,
  AppEvent
>((prev, event) => {
  switch (event.name) {
    case 'DemoStackURLResolved':
      return event.demoStackUrl;
    case 'DemoStackCreated':
      return undefined;
    default:
      return prev;
  }
});
